'use client';

import ErrorPage from './ErrorPage';

type GenericErrorPageProps = {
  locale: 'fr' | 'en';
};

const text: {
  fr: {
    title: string;
    description: string;
  };
  en: {
    title: string;
    description: string;
  };
} = {
  fr: {
    title: 'Une erreur est survenue',
    description:
      'Une erreur inattendue est survenue. Veuillez réessayer plus tard ou contacter le support si le problème persiste.',
  },
  en: {
    title: 'An unexpected error occurred',
    description:
      'An unexpected error occurred. Please try again later or contact support if the problem persists.',
  },
};
export default function GenericErrorPage({
  locale = 'fr',
}: GenericErrorPageProps) {
  return (
    <ErrorPage
      locale={locale}
      title={text[locale as keyof typeof text].title}
      description={text[locale as keyof typeof text].description}
      showBackButton={true}
      showHomeButton={true}
    />
  );
}
